import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const Measurement: React.FC<SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20" sx={{ fill: "none" }}>
      <rect width="20" height="20" rx="4" fill="#EC0089" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1391 4.29575C12.2327 4.20199 12.344 4.12761 12.4664 4.07687C12.5888 4.02612 12.7201 4 12.8526 4C12.9851 4 13.1164 4.02612 13.2388 4.07687C13.3612 4.12761 13.4725 4.20199 13.5661 4.29575L15.7042 6.43456C15.798 6.52821 15.8724 6.63943 15.9231 6.76184C15.9739 6.88426 16 7.01548 16 7.148C16 7.28052 15.9739 7.41174 15.9231 7.53416C15.8724 7.65657 15.798 7.76779 15.7042 7.86144L7.86193 15.7048C7.6728 15.8938 7.41633 16 7.1489 16C6.88148 16 6.625 15.8938 6.43588 15.7048L4.29579 13.5659C4.20202 13.4723 4.12763 13.3611 4.07688 13.2387C4.02612 13.1162 4 12.985 4 12.8525C4 12.72 4.02612 12.5888 4.07688 12.4663C4.12763 12.3439 4.20202 12.2327 4.29579 12.1391L12.1391 4.29575ZM6.30477 11.5562L5.0078 12.852L7.14789 14.9918L14.9922 7.1485L12.8531 5.00869L11.5562 6.30549L12.7301 7.47926L12.017 8.1922L10.8431 7.01842L10.0434 7.81808L11.2173 8.99186L10.5043 9.70479L9.33034 8.53102L8.53058 9.33068L9.7045 10.5045L8.99148 11.2174L7.81755 10.0436L7.01779 10.8433L8.19172 12.017L7.47869 12.73L6.30477 11.5562Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default Measurement;
